
import useGetQueryPagination from "./helper/ueGetPagination";
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetOneQuery from "./helper/useGetOneQuery";
import useUpdateMutation from "./helper/useUpdateMutation";
  
const API = {
  ADD: `key`,
  GET_ALL: `key`,
  DELETE: `key`,
  UPDATE: `key`,

};
const KEY = "key"


export const useGetKey = (params?:any) => useGetQueryPagination(KEY, API.GET_ALL,params);
export const useGetOneKey = () => useGetOneQuery(KEY, API.GET_ALL);

export const useAddKey = () => useAddMutation(KEY, API.ADD);
export const useUpdateKey = () => useUpdateMutation(KEY, API.UPDATE,true);

export const useDeleteKey = () =>useDeleteMutation(KEY, API.DELETE);
